<template>
  <div>
    <section>
      <div class="inner inner--full row5">
        <div class="title">
          <h1 class="alignC">설문 결과 데이터</h1>
        </div>

        <section>
          <div class="mt-10">
            <div class="surveyContainer">
              <div class="surveyContainer__left">
                <div
                  class="flex groupBtnRegisterSurvey"
                  v-if="user.roleName == this.$role.ADMIN"
                >
                  <a
                    href="javascript:void(0)"
                    class="btn-main btn-primary"
                    @click="isShowModal = true"
                    ><i class="ic ic--union"></i> 새 설문 데이터 등록</a
                  >
                  <!-- <a
                    href="javascript:void(0)"
                    class="btn-main btn-outline-secondary"
                    @click="itemsActive != null && (isShowModalEdit = true)"
                  >
                    수정
                  </a> -->
                  <a
                    href="javascript:void(0)"
                    class="btn-main btn-outline-secondary"
                    @click="itemsActive != null && (showAlertDelete = true)"
                    >삭제</a
                  >
                </div>
              </div>
              <div class="surveyContainer__right flex justify-between" >
                <div class = "alignL">
                  <AdminSurveyMultiselect 
                    v-model="selectedSurveyOptions" 
                    :externalOptions="surveyOptions"/>
                </div>
                <div class="alignR">
                  <template v-if="user.roleName == this.$role.ADMIN">
                    <span
                      class="btn-main btn-success cs-pointer"
                      @click="downFileAdmin"
                    >
                      <i class="ic ic--excel"></i> 엑셀 다운로드</span
                    >
                    <span style="padding: 2px;"></span>
                  </template>
                  <span
                      class="btn-main btn-success cs-pointer"
                      @click="downFile"
                    >
                      <i class="ic ic--excel"></i> 코드북 다운로드</span
                    >
                </div>
              </div>
            </div>
            <div class="surveyContainer surveyContainer--fix mt-2">
              <div class="surveyContainer__left">
                <div class="flex searchCommonBox">
                  <input
                    type="text"
                    class="searchInput"
                    v-model="searchText"
                    @keyup.enter="onClickSearch"
                    placeholder="검색할 설문명을 입력하세요."
                  />
                  <input
                    type="button"
                    value="검색"
                    class="searchBtn searchBtnCmmn"
                    @click="onClickSearch"
                  />
                  <input
                    type="button"
                    value="초기화"
                    class="searchResetBtn searchBtnCmmn mobileReset"
                    @click="onClickReset"
                  />
                </div>
                <div class="boxResult">
                  <div
                    class="boxResult__item"
                    v-for="(item, index) in items"
                    v-bind:class="{ active: item.idx == itemsActive.idx }"
                    :key="index"
                    @click="handleSelectItem(item)"
                  >
                    {{ item.title }}
                  </div>
                </div>
              </div>

              <div class="surveyContainer__right table-overflow-scroll">
                <AdminSurveyTable
                  :headers="surveyOptions"
                  :rowData="tableData"
                  :selectedHeaders="selectedSurveyOptions"/>
              </div>

            </div>
          </div>
        </section>
      </div>
    </section>

    <BasicModal
      disabledFooter
      :isShowModal="isShowModal"
      size="lg"
      title="새 설문 데이터 등록"
      @close-modal="handleCLose"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <form class="" @submit.prevent="handleSubmit(handleUploadSurvey)">
          <ValidationProvider
            name="설문 제목"
            rules="required"
            v-slot="{ errors }"
          >
            <InputField
              label="설문 제목"
              v-model="params.title"
              :errors="errors"
            />
          </ValidationProvider>

          <ValidationProvider
            rules="required"
            ref="provider1"
            v-slot="{ validate, errors }"
          >
            <InputFieldFile
              label="설문 데이터 업로드"
              btnText="파일 업로드"
              accept=".xlsx, .xls, .csv"
              :value="params.file1 ? params.file1.name : ''"
              :errors="errors"
              :change="handleFileChange1"
            />
          </ValidationProvider>

          <ValidationProvider
            ref="provider2"
            v-slot="{ validate, errors }"
          >
            <InputFieldFile
              label="코드북 업로드"
              btnText="파일 업로드"
              accept=".xlsx, .xls, .csv"
              :value="params.file2 ? params.file2.name : ''"
              :errors="errors"
              :change="handleFileChange2"
            />
          </ValidationProvider>

          <div style="height: 50px"></div>
          <div class="flex flexAlignC">
            <MainButton btnText="등록" type="submit" width="auto" />
          </div>
        </form>
      </ValidationObserver>
    </BasicModal>
    <BasicAlertModal
      :isShowModal="showAlertDelete"
      @close-modal="handleCLose"
      btnSubmitText="확인"
      size="md"
      :handleSubmit="handleDelete"
    >
    <h3>해당 설문 데이터를 삭제합니다.</h3>

    계속진행하시겠습니까?
    </BasicAlertModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import InputField from "@/components/formControl/InputField.vue";
import InputFieldFile from "@/components/formControl/InputFieldFile.vue";
import BasicAlertModal from "@/components/modal/BasicAlertModal";
import BasicModal from "@/components/modal/BasicModal";
import { apiBaseURL, resolveApiUrl } from "@/data/url";
import * as jwtUtil from "@/utils/jwtUtil";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";
import AdminSurveyMultiselect from "@/components/survey/admin/AdminSurveyMultiselect.vue";
import AdminSurveyTable from "@/components/survey/admin/AdminSuerveyTable.vue";

import { read, utils } from "xlsx";

export default {
  name: "SurveyManagement",
  components: {
    BasicModal,
    ValidationObserver,
    ValidationProvider,
    InputField,
    InputFieldFile,
    BasicAlertModal,
    MainButton,
    AdminSurveyMultiselect,
    AdminSurveyTable
  },
  data() {
    return {
      surveyOptions: [],
      tableData:[],
      selectedSurveyOptions: [],
      apiBaseURL: apiBaseURL,
      user: this.$store.state.auth.user,
      headers: {
        Authorization:
          "Bearer " +
          localStorage.getItem(jwtUtil.LOCAL_STORAGE_KEY_ACCESS_TOKEN),
        "My-Custom-Header": "foobar",
      },
      itemORG: [],
      items: [],
      itemsActive: {},
      searchText: "",
      params: {
        title: "",
        file1: null,
        file2: null,
      },
      isShowModalSurvey: false,
      detailSurveyIdx: null, // 등록: null, 수정: survey idx
      detailIsSubmited: false,
      form: {
        test: "",
      },
      isShowModal: false,
      isShowModalEdit: false,
      showAlertEdit: false,
      showAlertDelete: false,
    };
  },
  mounted() {
    this.getAllData();
  },
  methods: {
    ...mapActions("surveyData", [
      "getAll",
      "uploadSurvey",
      "deleteSurvey",
      "loadXML",
    ]),
    onSubmit() {},
    onClickSearch() {
      var that = this;
      const new_obj = that.lodash.filter(that.itemORG, function(o) {
        return o.title.includes(that.searchText);
      });
      that.items = new_obj;
    },
    onClickReset() {
      var that = this;
      that.items = that.lodash.clone(that.itemORG);
    },
    handleCLose() {
      this.isShowModal = false;
      this.isShowModalEdit = false;
      this.showAlertEdit = false;
      this.showAlertDelete = false;
    },
    showAlert() {
      this.$bvModal.show("alertModal");
    },
    getAllData() {
      const that = this;
      this.getAll()
        .then((res) => {
          that.items = res;
          that.itemORG = res;
          if (that.lodash.isEmpty(res[0])) {
            this.itemsActive = null;
          } else {
            that.itemsActive = res[0];
            that.loadData();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleSelectItem(item) {
      this.itemsActive = item;
      this.loadData();
    },
    handleUploadSurvey() {
      const that = this;
      this.uploadSurvey(this.params)
        .then(() => {
          that.handleCLose();
          that.getAllData();
          that.params = {
            title: "",
            file1: null,
            file2: null,
          };
        })
        .catch(() => {
          const that = this;
          that.handleCLose();
          that.$alert("알림", "파일 업로드 실패");
        });
    },
    async handleFileChange1(e) {
      const { valid } = await this.$refs.provider1.validate(e);

      if (valid) {
        this.params.file1 = e.target.files[0];
      }
    },
    async handleFileChange2(e) {
      const { valid } = await this.$refs.provider2.validate(e);

      if (valid) {
        this.params.file2 = e.target.files[0];
      }
    },
    handleDelete() {
      const that = this;
      if (this.itemsActive) {
        that
          .deleteSurvey(this.itemsActive.idx)
          .then(() => {
            that.getAllData();
            that.handleCLose();
          })
          .catch((error) => {
            alert(error);
          });
      }
    },
    async loadData() {
      const url = resolveApiUrl("/api/survey/data/");

      const that = this;
      if (!that.lodash.isEmpty(that.itemsActive)) {
        const f = await fetch(url+that.itemsActive.fileName, {
          headers: that.headers,
        });
        const ab = await f.arrayBuffer();
        // /* parse workbook */
        const wb = read(ab);
        this.getExcelHeaderAndBody(wb);
      }
    },
    getExcelHeaderAndBody(wb) {
      const firstSheet = wb.Sheets[wb.SheetNames[0]];
      const headers = utils.sheet_to_json(firstSheet, { header: 1 })[0];
      const rowData = utils.sheet_to_json(firstSheet, { header: headers });

      const columnData = headers.reduce((result, header) => {
        result[header] = rowData.slice(1).map(row => row[header] || null); // 첫 번째 행 제외
        return result;
      }, {});

      this.surveyOptions = headers.map((header, index) => ({
        id: index + 1, // 순서대로 ID 할당
        name: header,  // 헤더 이름
      }));
      this.tableData = columnData;
    },
    downFile() {
      const url = resolveApiUrl("/api/survey/data/");

      const that = this;
      if (!that.lodash.isEmpty(that.itemsActive)) {
        that.loadXML({
          link: url+that.itemsActive.fileName2,
          name: that.itemsActive.realFileName2,
        });
      }
    },
    downFileAdmin() {
      const url = resolveApiUrl("/api/survey/data/");

      const that = this;
      if (!that.lodash.isEmpty(that.itemsActive)) {
        that.loadXML({
          link: url+that.itemsActive.fileName,
          name: that.itemsActive.realFileName,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tableResult ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
  table {
    --bs-border-color: #ceced4;
    --bs-table-color-type: initial;
    --bs-table-bg-type: initial;
    --bs-table-color-state: initial;
    --bs-table-bg-state: initial;
    --bs-table-color: var(--bs-body-color);
    --bs-table-bg: var(--bs-body-bg);
    --bs-table-border-color: var(--bs-border-color);
    --bs-table-accent-bg: transparent;
    --bs-table-striped-color: var(--bs-body-color);
    --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
    --bs-table-active-color: var(--bs-body-color);
    --bs-table-active-bg: rgba(0, 0, 0, 0.1);
    --bs-table-hover-color: var(--bs-body-color);
    --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
    width: 100%;
    margin-bottom: 1rem;
    vertical-align: top;
    border-color: var(--bs-table-border-color);

    & > :not(caption) > * > * {
      padding: 0.5rem 0.5rem;
      color: var(
        --bs-table-color-state,
        var(--bs-table-color-type, var(--bs-table-color))
      );
      background-color: var(--bs-table-bg);
      border-bottom-width: var(--bs-border-width);
      box-shadow: inset 0 0 0 9999px
        var(
          --bs-table-bg-state,
          var(--bs-table-bg-type, var(--bs-table-accent-bg))
        );
    }

    & > :not(caption) > * {
      border-width: var(--bs-border-width) 0;
    }

    & > :not(caption) > * > * {
      border-width: 0 var(--bs-border-width);
    }
  }
}
</style>
